import { Dispatch, SetStateAction, createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { ChildProps } from '@/common/util/props'

interface AppHeaderState {
  hiding: boolean
  setHiding: Dispatch<SetStateAction<boolean>>
}

const defaultValue: AppHeaderState = {
  hiding: false,
  setHiding: () => {}
}

export const AppHeaderStateContext = createContext<AppHeaderState>(defaultValue)

export const useAppHeaderHiding = (hiding: boolean) => {
  const { setHiding } = useContext(AppHeaderStateContext)
  useEffect(() => {
    setHiding(hiding)
  }, [hiding])
}

const AppHeaderProvider = ({ children }: ChildProps) => {
  const [hiding, setHiding] = useState<boolean>(false)

  const { pathname } = useLocation()

  useEffect(() => {
    setHiding(false)
  }, [pathname])

  return (
    <AppHeaderStateContext.Provider
      value={{
        hiding,
        setHiding
      }}
    >
      {children}
    </AppHeaderStateContext.Provider>
  )
}

export default AppHeaderProvider
